<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">项目信息详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col>
              <el-form-item label="项目名称" prop="ProjectName">
                <el-input v-model="data.ProjectName" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="计划开始时间" prop="ProjectStartTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.ProjectStartTime"
                  format="yyyy-MM-dd hh:mm"
                  :disabled="IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计划结束时间" prop="ProjectEndTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.ProjectEndTime"
                  format="yyyy-MM-dd hh:mm"
                  :disabled="IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="项目详情" prop="ProjectDescription">
              <el-input
                v-model="data.ProjectDescription"
                :disabled="IsEdit"
                type="textarea"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目状态" prop="ProjectStatus">
                <el-select
                  v-model="data.ProjectStatus"
                  placeholder="请选择"
                  :disabled="IsEdit"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in ProjectStatusList"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目进度" prop="ProjectProgress">
                <el-select
                  v-model="data.ProjectProgress"
                  placeholder="请选择"
                  :disabled="IsEdit"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in ProjectProgressList"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目部" prop="ProjectOrg">
                <el-input v-model="data.ProjectOrg" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目负责人" prop="ProjectCharger">
                <el-input v-model="data.ProjectCharger" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="执行方" prop="ProjectExcuteOrg">
                <el-input v-model="data.ProjectExcuteOrg" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行方负责人" prop="ProjectExcuteCharger">
                <el-input v-model="data.ProjectExcuteCharger" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行方负责人手机" prop="ProjectExcutePhone">
                <el-input v-model="data.ProjectExcutePhone" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="验收方" prop="ProjectCheckOrg">
                <el-input v-model="data.ProjectCheckOrg" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="验收方负责人" prop="ProjectCheckCharger">
                <el-input v-model="data.ProjectCheckCharger" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="验收方负责人手机" prop="ProjectCheckPhone">
                <el-input v-model="data.ProjectCheckPhone" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="assocID">
            <FileList :assocID="assocID" :module="module"></FileList>
          </el-row>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right" style="width: 134rem;padding-right:5rem">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="saveStatus()" v-show="showguidang">归档</el-button>
          <el-button type="primary" @click="saveForm()" v-show="!IsEdit">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>


<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import FileList from "../MaterialManage/FileList";
export default {
  name: "ProjectInfo",
  controller: "UI",
  action: "ProjectInfo",
  components: {
    FileList,
  },
  data() {
    return {
      data: {},
      assocID: "",
      module: "",
      loading: false,
      loadingText: "加载中...",
      showguidang: false,
      IsEdit: false,
      ProjectStatusList: [
        { lable: "编辑中", value: 1 },
        { lable: "进行中", value: 2 },
        { lable: "已归档", value: 3 },
        { lable: "已延期", value: 4 },
        { lable: "已停止", value: 5 },
      ],
      ProjectProgressList: [
        { lable: "0%", value: "0%" },
        { lable: "10%", value: "10%" },
        { lable: "20%", value: "20%" },
        { lable: "30%", value: "30%" },
        { lable: "40%", value: "40%" },
        { lable: "50%", value: "50%" },
        { lable: "60%", value: "60%" },
        { lable: "70%", value: "70%" },
        { lable: "80%", value: "80%" },
        { lable: "90%", value: "90%" },
        { lable: "100%", value: "100%" },
      ],
      rules: {
        ProjectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        ProjectStartTime: [
          { required: true, message: "请输选择计划开始时间", trigger: "blur" },
        ],
        ProjectEndTime: [
          { required: true, message: "请输选择计划结束时间", trigger: "blur" },
        ],
        ProjectDescription: [
          { required: true, message: "请输入项目详情", trigger: "blur" },
        ],
        ProjectStatus: [
          { required: true, message: "请输选择项目状态", trigger: "blur" },
        ],
        ProjectProgress: [
          { required: true, message: "请输入项目进度", trigger: "blur" },
        ],
        ProjectOrg: [
          { required: true, message: "请输入项目部", trigger: "blur" },
        ],
        ProjectCharger: [
          { required: true, message: "请输入项目负责人", trigger: "blur" },
        ],
        ProjectExcuteOrg: [
          { required: true, message: "请输入执行方", trigger: "blur" },
        ],
        ProjectExcuteCharger: [
          { required: true, message: "请输入执行方负责人", trigger: "blur" },
        ],
        ProjectExcutePhone: [
          {
            required: true,
            message: "请输入执行方负责人手机",
            trigger: "blur",
          },
        ],
        ProjectCheckOrg: [
          { required: true, message: "请输入验收方", trigger: "blur" },
        ],
        ProjectCheckCharger: [
          { required: true, message: "请输入验收方负责人", trigger: "blur" },
        ],
        ProjectCheckPhone: [
          {
            required: true,
            message: "请输入验收方负责人手机",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created: function () {
    if (this.$route.query.type == "edit") {
      this.showguidang = true;
    }

    if (this.$route.query.InfoId) {
      this.assocID = this.$route.query.InfoId;
      this.search();
    }

    if (this.$route.query.module) {
      this.module = this.$route.query.module;
    }
    if (this.$route.query.ProjectStatus == 3) {
      this.showguidang = false;
      this.IsEdit = true;
    }
  },
  mounted: function () {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          if (this.$route.query.type == "add") {
            this.Add();
          } else if (this.$route.query.type == "edit") {
            this.Edit();
          }
        } else {
          return false;
        }
      });
    },
    Add() {
      this.data.ID = ZJApp.ZJUtils.uuid();
      this.data.Validity = 1;
      this.data.CreateTime = new Date();
      this.data.Creater = ZJApp.ZJUser.current.UserName;
      new MyApis.ProjectBasicinfoApi()
        .AddItem(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.data.ModifyTime = new Date();
      this.data.Modifier = ZJApp.ZJUser.current.UserName;
      new MyApis.ProjectBasicinfoApi()
        .UpdateItem(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveStatus() {
      this.data.ModifyTime = new Date();
      this.data.Modifier = ZJApp.ZJUser.current.UserName;
      this.data.ProjectStatus = 3;
      new MyApis.ProjectBasicinfoApi()
        .UpdateItem(this.data)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "归档成功！" : "归档失败！",
          });
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.ProjectBasicinfoApi()
          .GetItemById({ ID: InfoId })
          .then((r) => {
            r = r.data.Data;
            this.data = r;

            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
